import { render, staticRenderFns } from "./SchoolSchedule.vue?vue&type=template&id=f01d360c"
import script from "./SchoolSchedule.vue?vue&type=script&lang=js"
export * from "./SchoolSchedule.vue?vue&type=script&lang=js"
import style0 from "./SchoolSchedule.vue?vue&type=style&index=0&id=f01d360c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports